import {Injectable} from '@angular/core';
import {AngularFirestore} from 'angularfire2/firestore';
import {Subject} from 'rxjs/Subject';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class FirebaseSettingsService {

  constructor(private afs: AngularFirestore) {
  }


  /**
   * Get Setting per Property > section > Role:landlord
   * @param {string} org_id
   * @param {string} property_id
   * @returns {Observable<any>}
   */
  getLandlordSettingByPropertyandSection(org_id: string, property_id: string, section: string, setting_id): Observable<any> {
    const settingRef = this.afs.collection<any>('organizations')
      .doc(org_id).collection('properties').doc(property_id).collection('settings')
      .doc(section).collection('landlord').doc(setting_id);
    return settingRef.valueChanges();
  }


  /**
   * Get Setting per Property > section > Role:tenant
   * @param {string} org_id
   * @param {string} property_id
   * @param {string} section
   * @returns {Observable<any>}
   */
  getTenantSettingByPropertyandSection(org_id: string, property_id: string, section: string, setting_id): Observable<any> {
    const settingRef = this.afs.collection<any>('organizations')
      .doc(org_id).collection('properties').doc(property_id).collection('settings')
      .doc(section).collection('tenant').doc(setting_id);
    return settingRef.valueChanges();
  }


  /**
   * Update Setting per Property > section > Role:landlord > setting_id
   * @param {string} org_id
   * @param {string} property_id
   * @param {string} section
   * @param {string} setting_id
   * @param formValue
   * @returns {Observable<any>}
   */
  updateLanlordSettingByPropertyandSection(org_id: string, property_id: string, section: string,
                                           fieldName: string, fieldValue: boolean, setting_id: string): Observable<any> {
    const settingRef = this.afs.collection<any>('organizations')
      .doc(org_id).collection('properties').doc(property_id).collection('settings')
      .doc(section).collection('landlord').doc(setting_id);

    const transaction = settingRef.set({
      [fieldName] : fieldValue
    });

    return this.fromFirebaseAuthPromise(transaction);

  }


  /**
   * Update Setting per Property > section > Role:tenant
   * @param {string} org_id
   * @param {string} property_id
   * @param {string} section
   * @param {string} setting_id
   * @param formValue
   * @returns {Observable<any>}
   */
  updateTenantSettingByPropertyandSection(org_id: string, property_id: string, section: string,
                                          fieldName: string, fieldValue: boolean, setting_id: string): Observable<any> {
    const settingRef = this.afs.collection<any>('organizations')
      .doc(org_id).collection('properties').doc(property_id)
      .collection('settings').doc(section).collection('tenant').doc(setting_id);

    const transaction = settingRef.set({
      [fieldName] : fieldValue
    });

    return this.fromFirebaseAuthPromise(transaction);
  }

  // Convert Promise of Firebase to an Observable
  fromFirebaseAuthPromise(promise): Observable<any> {

    const subject = new Subject<any>();

    promise
      .then(res => {
          subject.next(res);
          subject.complete();
        },
        err => {
          subject.error(err);
          subject.complete();
        }
      );
    return subject.asObservable();
  }


}



// WEBPACK FOOTER //
// C:/Clients/rent-hero/web-application/src/app/_shared/services/firebase/settings.service.ts